<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g id="flow-chart" transform="translate(20 20) rotate(180)">
            <path
                d="M14.667,7.994,12.8,6.126H8V7.793H3v-5H8V4.459h4.8l2.7-2.7,3.536,3.537-2.7,2.7a11.258,11.258,0,0,1-.833.881S15,8.311,14.667,7.994Zm.833-3.88L14.322,5.293,15.5,6.471l1.178-1.178Zm-9.167.345H4.667V6.126H6.333Z"
                transform="translate(-1.333 4.911)"
                :fill="color"
            />
        </g>
    </svg>
</template>

<script>
import IconBase from '@/components/icons/IconBase'

export default {
    name: 'IconFlowGraphTo',
    extends: IconBase
}
</script>

<style scoped lang="scss">

</style>
